export class SetProjectsWithEvents {
    static type = "[Projects] Set projects with events";

    constructor(public payload: Object) {}
}
